import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { wasInDashboardBefore } from "src/duck/selectors";
import { getFamilyName } from "src/modules/auth/duck/selectors";
import PairingSuccess from "src/modules/pairing/scenes/Success";
import * as selectors from "../../duck/selectors";
import resolveText from "./resolveText";

export default function PairingRequesterSuccess({
  flow,
  dispatch,
  closeWizard,
  location,
  pathname,
  ...rest
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pairingType } = useSelector(selectors.getRequest) || {};

  const deviceName = useSelector(selectors.getResponderDeviceName);
  const familyName = useSelector(getFamilyName);
  const responderFamilyName = useSelector(selectors.getResponderFamilyName);
  const shouldGoToDashboad = !useSelector(wasInDashboardBefore);

  function onDone() {
    shouldGoToDashboad && navigate("/dashboard");
    closeWizard();
  }

  const text = resolveText({
    pairingType,
    familyName,
    responderFamilyName,
    t,
    deviceName,
    didLogIn: flow.state.didLogIn,
    didSignUp: flow.state.didSignUp
  });

  return (
    <PairingSuccess
      text={text}
      onDone={onDone}
      onClose={closeWizard}
      {...rest}
    />
  );
}
